<template>
  <div>
    <div class="container">
      <div class="card">
        <div class="card-header">
          Admin
        </div>
        <div class="card-body">
          <h5 class="card-title">Admin</h5>
          <p class="card-text">
            Admin Admin Admin Admin Admin Admin
            Admin Admin Admin Admin Admin Admin
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'admin',
  components: {
  },
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue